var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 62,
    viewBox: "0 0 76 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_936_9485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.6941 59.3206C27.16 59.5713 26.3034 59.5523 25.7808 59.2783L18.2117 55.3083L18.2291 55.3002C18.3859 55.2266 18.4171 55.133 18.6673 55.0691C18.7574 55.0156 18.8427 54.9607 18.9232 54.9046C20.4514 53.8397 20.2564 52.3265 18.3174 51.3095C16.1227 50.1584 12.525 50.0788 10.2816 51.1318L10.2643 51.14L2.50592 47.0708C1.98339 46.7967 1.85734 45.6615 2.39148 45.4108L48.3695 24.604C48.9037 24.3533 49.7603 24.3723 50.2828 24.6463L57.241 28.2958L58.0412 28.7156C58.0326 28.7195 58.024 28.7235 58.0154 28.7276C55.7721 29.7805 55.7326 31.5672 57.9272 32.7183C60.1219 33.8694 63.7196 33.9489 65.963 32.896C65.9715 32.892 65.9801 32.8879 65.9886 32.8839L73.7589 36.2227C74.1862 36.4364 74.0709 37.5533 73.5367 37.804L27.6941 59.3206Z",
    fill: "#B0751C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 55.0691C18.7574 55.0156 18.8427 54.9607 18.9232 54.9046L18.2291 54.542V55.3002L18.6673 55.0691Z",
    fill: "#B0751C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.241 28.2958L58.0412 28.7156L58.0154 27.9308L57.8401 27.9963L57.241 28.2958Z",
    fill: "#B0751C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6939 58.5458C27.1598 58.7966 26.3032 58.7776 25.7806 58.5035L18.2115 54.5336L18.2289 54.5255C20.4723 53.4725 20.5118 51.6858 18.3172 50.5347C16.1225 49.3837 12.5248 49.3041 10.2814 50.3571L10.264 50.3652L2.5057 46.296C1.98317 46.022 1.99258 45.5966 2.52671 45.3459L48.3693 23.8293C48.9035 23.5786 49.7601 23.5975 50.2826 23.8716L58.041 27.9408C58.0324 27.9448 58.0238 27.9488 58.0152 27.9528C55.7718 29.0058 55.7323 30.7925 57.927 31.9436C60.1216 33.0946 63.7194 33.1742 65.9628 32.1212C65.9713 32.1172 65.9799 32.1132 65.9884 32.1091L73.5575 36.0791C74.0801 36.3532 74.0706 36.7786 73.5365 37.0293L27.6939 58.5458Z",
    fill: "#ECA601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0492 32.2705L21.4082 44.5568M55.9167 36.7577L30.7031 49.2577",
    stroke: "white",
    strokeWidth: 0.641025
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6941 48.1087C27.16 48.3594 26.3034 48.3404 25.7808 48.0664L18.2117 44.0964L18.2291 44.0883C18.3859 44.0147 18.4171 43.9211 18.6673 43.8572C18.7574 43.8037 18.8427 43.7488 18.9232 43.6927C20.4514 42.6278 20.2564 41.1146 18.3174 40.0976C16.1227 38.9465 12.525 38.8669 10.2816 39.9199L10.2643 39.9281L2.50592 35.8589C1.98339 35.5848 1.85734 34.4495 2.39148 34.1988L48.3695 13.3921C48.9037 13.1414 49.7603 13.1604 50.2828 13.4344L57.241 17.0839L58.0412 17.5036C58.0326 17.5076 58.024 17.5116 58.0154 17.5157C55.7721 18.5686 55.7326 20.3553 57.9272 21.5064C60.1219 22.6575 63.7196 22.737 65.963 21.6841C65.9715 21.68 65.9801 21.676 65.9886 21.672L73.7589 25.0108C74.1862 25.2245 74.0709 26.3414 73.5367 26.5921L27.6941 48.1087Z",
    fill: "#B0751C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 43.8572C18.7574 43.8037 18.8427 43.7488 18.9232 43.6927L18.2291 43.33V44.0883L18.6673 43.8572Z",
    fill: "#B0751C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.241 17.0839L58.0412 17.5036L58.0154 16.7189L57.8401 16.7843L57.241 17.0839Z",
    fill: "#B0751C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6939 47.333C27.1598 47.5837 26.3032 47.5647 25.7806 47.2907L18.2115 43.3207L18.2289 43.3126C20.4723 42.2596 20.5118 40.4729 18.3172 39.3218C16.1225 38.1708 12.5248 38.0912 10.2814 39.1442L10.264 39.1523L2.5057 35.0832C1.98317 34.8091 1.99258 34.3837 2.52671 34.133L48.3693 12.6164C48.9035 12.3657 49.7601 12.3846 50.2826 12.6587L58.041 16.7279C58.0324 16.7319 58.0238 16.7359 58.0152 16.7399C55.7718 17.7929 55.7323 19.5796 57.927 20.7307C60.1216 21.8818 63.7194 21.9613 65.9628 20.9084C65.9713 20.9043 65.9799 20.9003 65.9884 20.8963L73.5575 24.8662C74.0801 25.1403 74.0706 25.5657 73.5365 25.8164L27.6939 47.333Z",
    fill: "#ECA601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0492 21.0576L21.4082 33.3439M55.9167 25.5448L30.7031 38.0448",
    stroke: "white",
    strokeWidth: 0.641025
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6941 36.8968C27.16 37.1475 26.3034 37.1285 25.7808 36.8545L18.2117 32.8845L18.2291 32.8764C18.3859 32.8028 18.4171 32.7091 18.6673 32.6453C18.7574 32.5918 18.8427 32.5369 18.9232 32.4808C20.4514 31.4159 20.2564 29.9027 18.3174 28.8856C16.1227 27.7346 12.525 27.655 10.2816 28.708L10.2643 28.7161L2.50592 24.647C1.98339 24.3729 1.85734 23.2376 2.39148 22.9869L48.3695 2.18021C48.9037 1.92951 49.7603 1.94845 50.2828 2.22252L57.241 5.872L58.0412 6.29172C58.0326 6.29571 58.024 6.29972 58.0154 6.30374C55.7721 7.35669 55.7326 9.1434 57.9272 10.2945C60.1219 11.4456 63.7196 11.5251 65.963 10.4722C65.9715 10.4681 65.9801 10.4641 65.9886 10.4601L73.7589 13.7989C74.1862 14.0126 74.0709 15.1295 73.5367 15.3802L27.6941 36.8968Z",
    fill: "#B0751C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6673 32.6453C18.7574 32.5918 18.8427 32.5369 18.9232 32.4808L18.2291 32.1181V32.8764L18.6673 32.6453Z",
    fill: "#B0751C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.241 5.872L58.0412 6.29172L58.0154 5.50698L57.8401 5.57242L57.241 5.872Z",
    fill: "#B0751C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.6939 36.121C27.1598 36.3717 26.3032 36.3528 25.7806 36.0787L18.2115 32.1088L18.2289 32.1007C20.4723 31.0477 20.5118 29.261 18.3172 28.1099C16.1225 26.9589 12.5248 26.8793 10.2814 27.9323L10.264 27.9404L2.5057 23.8712C1.98317 23.5972 1.99258 23.1718 2.52671 22.9211L48.3693 1.4045C48.9035 1.1538 49.7601 1.17274 50.2826 1.4468L58.041 5.51601C58.0324 5.52 58.0238 5.524 58.0152 5.52803C55.7718 6.58097 55.7323 8.36769 57.927 9.51876C60.1216 10.6698 63.7194 10.7494 65.9628 9.69644C65.9713 9.69242 65.9799 9.68838 65.9884 9.68434L73.5575 13.6543C74.0801 13.9284 74.0706 14.3538 73.5365 14.6045L27.6939 36.121Z",
    fill: "#ECA601"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.0492 9.8457L21.4082 22.132M55.9167 14.3329L30.7031 26.8329",
    stroke: "white",
    strokeWidth: 0.641025
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_936_9485",
    x: 0.70487,
    y: 0.950195,
    width: 74.5727,
    height: 60.2563,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.8547
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.42735
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_936_9485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_936_9485",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket);
export default __webpack_public_path__ + "static/media/ticket.c205e3e0dd3707f948b5817cfb1badd5.svg";
export { ForwardRef as ReactComponent };